// extracted by mini-css-extract-plugin
module.exports = {"content":"people-team-m__content__12tlP","header-wrapper":"people-team-m__header-wrapper__2epPx"};